























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { qcRedos } from '@/api/task/crowd';
import { detail as taskDetail } from '@/api/task/common';
import { detail as judgeDetail } from '@/api/task/judge';
import {DOMAIN, HTTPDOMAIN, mobileProject,JIDU_DOMAIN} from '@/global/constants';

@Component
export default class Inpect extends Vue {
  private dataList: object[] = [];
  private total: number | string = 0;
  private task: object = {};

  // 搜索 入参
  private searchParams: object = {
    mlid: '',
    uid: '',
  };
  // 默认 入参
  private listParams: object = {
    page: 1,
    pagesize: 20,
  };

  private columnsSchema: object[] = [
    {
      title: '序号',
      key: 'index',
      align: 'center',
    },
    {
      title: '题目ID',
      key: 'id',
      align: 'center',
    },
    {
      title: '标注人ID',
      key: 'puid',
      align: 'center',
    },
    {
      title: '提交时间',
      key: 'time',
      align: 'center',
      slot: 'time',
    },
    {
      title: '审核',
      key: 'answer',
      align: 'center',
      slot: 'operate',
    },
  ];
  @Watch('$route')
  private routechange(to: any, from: any) {
    if (to.name == 'checkfirst') {
      this.getList({});
      this.getTask();
    }
  }
  private created() {
    this.getList({});
    this.getTask();
  }
  private async getList(params) {
    // 列表 入参
    if(this.$route.params.pkg_id){
      params.pkg_id =this.$route.params.pkg_id
    }
    const new_params = Object.assign(
      { mid: this.$route.params.id },
      this.listParams,
      params
    );
    try {
      const data = (await qcRedos(new_params)) as any;
      // 序号根据分页递增
      data.rows.map((item, idx) => {
        item.index =
          idx +
          1 +
          ((new_params as any).page - 1) * (new_params as any).pagesize;
        return item;
      });
      this.$nextTick(() => {
        this.dataList = data.rows;
        this.total = data.total;
      });
    } catch (error) {
      console.log(error);
    }
  }

  private goPrev() {
    (window as any).history.back(-1);
  }
  private async getTask() {
    this.task = this.$store.state.task;
    if (!(this.task && (this.task as any).id)) {
      const page = this.$route.params.page;
      const params = { id: this.$route.params.id };
      let resp: any;
      if(page =='judge'){
        resp = await judgeDetail(params);
      } else {
        resp = await taskDetail(params);
      }
      this.$nextTick(() => {
        this.task = resp.result;
        this.$store.commit('setTask', resp.result);
      });
    }
  }

  // 搜索
  private handleSearch() {
    let options = {};
    const params = this.searchParams;

    for (let key in params) {
      if (params[key] !== '') {
        options[key] = params[key];
      }
    }
    this.getList(options);
  }
  // 重置
  private handlereset() {
    this.searchParams = {
      mlid: '',
      uid: '',
    };
    this.getList({});
  }
  // 分页
  private changePage(data) {
    (this.listParams as any).page = data;
    let options = {};
    const params = this.searchParams;

    for (let key in params) {
      if (params[key] !== '') {
        options[key] = params[key];
      }
    }
    this.getList(options);
  }
  // 切换分页条数
  private changePageSize(data) {
    (this.listParams as any).pagesize = data;
    this.changePage(1);
  }
  // 审核
  private handlecheck(id, mlid, uid) {
    if ((this.task as any).from) {
      let url = `${DOMAIN}/tools/`
      // 移动asr项目 https无法访问 改为http访问
      if(id && mobileProject.indexOf(id * 1) > -1){
        url = `${HTTPDOMAIN}/tools/`
      }
      
      //JiDu兼容之前的跳转
      let newUrl = `${url}${(this.task as any).from}.html?type=55&id=${id}&mlid=${mlid}&uid=${uid}&stage=2&version=2`

      //JiDu兼容jiduNlpPage
      if((this.task as any).from === 'jiduNlpPage'){
        newUrl = `${JIDU_DOMAIN}/nlp?type=55&id=${id}&mlid=${mlid}&uid=${uid}&stage=2&version=2`
      }
      window.open(newUrl);
    } else {
      window.open(
        `${DOMAIN}/tools/markPage.html?type=55&id=${id}&mlid=${mlid}&uid=${uid}&stage=2&version=2`
      );
    }
  }
}
